import {Controller} from "@hotwired/stimulus"
import {Modal} from "bootstrap"

// Connects to data-controller="show-modal"
export default class extends Controller {
  static targets = ["modal"]

  connect() {
    new Modal(this.modalTarget).show()
    document.addEventListener("turbo:before-cache", this.turboBeforeCache.bind(this))
  }

  turboBeforeCache() {
    this.modalTarget.remove();
    document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove());
  }
}
